import { getCurrentQuarterRange } from '../../utils/time.ts'
import { createSelector, createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store.ts'
import dayjs from 'dayjs'

interface DashboardInputState {
  dateRange: [string | null, string | null]
}

export const dashboardInputSlice = createSlice({
  name: 'dashboardInput',
  initialState: {
    dateRange: getCurrentQuarterRange() as [string, string],
  } as DashboardInputState,
  reducers: {
    setDashboardInputDateRange: (state, action) => {
      state.dateRange = [
        action.payload?.[0] ? action.payload[0] : null,
        action.payload?.[1] ? action.payload[1] : null,
      ]
    },
  },
})

const selectDashboardInputState = (state: RootState) => state.dashboardInput

export const selectDashboardInput = createSelector(
  [selectDashboardInputState],
  (input) => ({
    ...input,
    dateRange: [
      input.dateRange?.[0] ? dayjs(input.dateRange[0]) : null,
      input.dateRange?.[1] ? dayjs(input.dateRange[1]) : null,
    ],
  })
)

export const { setDashboardInputDateRange } = dashboardInputSlice.actions
